import { Card, Col, Divider, Empty, Row } from 'antd';
import CustomFileList from 'components/CustomFileList';
import DrawerComponent from 'components/Drawer';
import TagComponent from 'components/Tags';
import TaskInfo from 'components/TaskInfo';
import { useTranslation } from 'react-i18next';
import { getStatusValues, renderDate } from 'utils/helpers';
import { SelectTaskData } from '../../sales-group-progress';
import DryEventContent from './task-drawer/DryEventContent';
import FertilizerLogContent from './task-drawer/FertilizerLogContent';
import HarvestContent from './task-drawer/HarvestContent';
import PipeInstallationContent from './task-drawer/PipeInstallationContent';
import PreHarvestContent from './task-drawer/PreHarvestContent';
import StartSeasonContent from './task-drawer/StartSeasonContent';

type TaskDrawerProps = {
  data?: SelectTaskData;
  open: boolean;
  onClose: () => void;
};

const TaskDrawer = ({ data, open, onClose }: TaskDrawerProps) => {
  const { task } = { ...data };
  const { t } = useTranslation();

  const renderContent = () => {
    if (task?.status === 'BLOCKED') {
      const {
        text: iconText,
        color: iconColor,
        textColor,
      } = getStatusValues(task.status);
      return (
        <>
          <Card>
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <TaskInfo
                  header={t('dashboard.installationStatus')}
                  value={
                    <TagComponent
                      textColor={textColor}
                      color={iconColor}
                      label={iconText}
                    />
                  }
                />
              </Col>
              <Col span={12}>
                <TaskInfo
                  header={t('dashboard.taskTimeWindow')}
                  value={
                    <>
                      {renderDate(task.dueDate)} {task.endDate && '-'}{' '}
                      {renderDate(task.endDate, '')}
                    </>
                  }
                />
              </Col>
              <Col span={12}>
                <TaskInfo
                  header={t('dashboard.taskCompletionDate')}
                  value={renderDate(task.inputDate)}
                />
              </Col>
              <Divider style={{ margin: '12px 0' }} />
              <Col span={12}>
                <TaskInfo
                  header={t('dashboard.blockedReason')}
                  value={task.blockedReason}
                />
              </Col>
              <Col span={12}>
                <TaskInfo
                  header={t('dashboard.pictureOfProof')}
                  value={
                    <CustomFileList
                      images={task.proofBlocked?.map((img) => img.url)}
                    />
                  }
                />
              </Col>
            </Row>
          </Card>
        </>
      );
    }

    switch (data?.task?.taskSubType) {
      case 'START_SEASON':
        return <StartSeasonContent data={data} />;

      case 'FERTILIZER_LOG':
      case 'FERTILISER_LOG':
        return <FertilizerLogContent data={data} />;

      case 'PIPE_INSTALLATION':
        return <PipeInstallationContent data={data} />;

      case 'VISIT_30':
        return <DryEventContent data={data} />;

      case 'PRE_HARVEST_MEETING':
        return <PreHarvestContent data={data} />;

      case 'HARVEST':
        return <HarvestContent data={data} />;

      default:
        if (data?.task?.taskSubType.startsWith('DRYING_EVENT'))
          return <DryEventContent data={data} />;
        return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
    }
  };

  return (
    <DrawerComponent
      title={data?.task?.description}
      open={open}
      onClose={onClose}
      content={renderContent()}
    />
  );
};

export default TaskDrawer;
